import { Utils } from "@/plugins/utils"

const stringNumericFields = ["fn3iniblq", "fn3fimblq"]
const decimalFields = ["fn3juros", "fn3diaspro", "fn3multa"]

function sanitizeFn3(fn3) {
	let sanitized = { ...fn3 }
	stringNumericFields.forEach(field => {
		if (sanitized[field] === null || sanitized[field] === undefined) sanitized[field] = ""
		else sanitized[field] = String(sanitized[field])
	})
	decimalFields.forEach(field => {
		if (sanitized[field] === "" || sanitized[field] === null || sanitized[field] === undefined) sanitized[field] = 0
	})
	return sanitized
}

function flattenFn3(viewModel) {
	return viewModel ? { ...viewModel.fn3, dr1nome: viewModel.dr1nome } : null
}

export default {
	namespaced: true,
	state: {
		lstFn3: [],
		fn3: null,
		insert: false,
		update: false,
		loading: false,
		show: false,
	},
	getters: {
		getFn3: state => state.fn3,
		getLstFn3: state => state.lstFn3,
		getInsert: state => state.insert,
		getUpdate: state => state.update,
		getLoading: state => state.loading,
	},
	mutations: {
		set(state, fn3) {
			state.fn3 = fn3
			state.insert = false
			if (fn3) state.update = true
		},
		setFn3(state, fn3) {
			state.fn3 = fn3
			if (fn3) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.fn3 = null
			state.show = false
		},
		setLstFn3(state, lstFn3) {
			state.lstFn3 = lstFn3
		},
		setLoading(state, loading) {
			state.loading = loading
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async findList({ commit, dispatch }, fn3agente) {
			commit("setLoading", true)
			await this._vm.$axios
				.get(`/Financial/BankAccount/FindList/${fn3agente}`)
				.then(response => {
					let lstFn3 = (Utils.ValidateAxiosResponse(response.data) || []).map(flattenFn3)
					commit("setLstFn3", lstFn3)
				})
				.catch(error => {
					commit("setLstFn3", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		async findLstFn3({ commit, dispatch }) {
            commit("setLoading", true)
            try {
                const response = await this._vm.$axios.get("/Financial/LiquidationTitle/FindListFn3/")
                const result = Utils.ValidateAxiosResponse(response.data)
                commit("setLstFn3", result)

                return result
            } catch (error) {
                commit("setLstFn3", [])
                dispatch("parameters/openDialog", {
                titleText: "Erro",
                titleColor: "red",
                text: error.message
                }, { root: true })
                return []
            } finally {
                commit("setLoading", false)
            }
        },
		async find({ commit, dispatch }, { fn3agente, fn3conta }) {
			commit("setLoading", true)
			await this._vm.$axios
				.get(`/Financial/BankAccount/Find/${fn3agente}/${fn3conta}`)
				.then(response => {
					let fn3 = flattenFn3(Utils.ValidateAxiosResponse(response.data))
					commit("set", fn3)
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		save({ state, dispatch }) {
			if (state.update) {
				return dispatch("update")
			}
			return dispatch("insert")
		},
		async insert({ state, dispatch, commit }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.post("/Financial/BankAccount/Insert", sanitizeFn3(state.fn3))
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					state.show = false
					dispatch("findList", state.fn3.fn3agente)
					commit("set", null)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ state, dispatch, commit }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.put("/Financial/BankAccount/Update", sanitizeFn3(state.fn3))
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					state.show = false
					dispatch("findList", state.fn3.fn3agente)
					commit("set", null)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch }, { fn3agente, fn3conta }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.delete(`/Financial/BankAccount/Delete/${fn3agente}/${fn3conta}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					dispatch("findList", fn3agente)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
